import { MaxWinConfig } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/paytableContentFactory/AbstractPaytableContentFactory";

type LineCount = number;
type Rtp = number;

type RtpConfig = Record<Rtp, MaxWinConfig>;
type MaxWinConfigsByLineCount = Record<LineCount, RtpConfig | undefined>

export const maxWinConfigsByLineCount: MaxWinConfigsByLineCount = {
    5: {
        88.02: {
            maxWinAmountInCents: 76500,
            betAmountInCents: 100,
            minRatio: 1,
            maxRatio: 1000000
        }
    },
    30: {
        87.99: {
            maxWinAmountInCents: 25260,
            betAmountInCents: 60,
            minRatio: 1,
            maxRatio: 1000000
        }
    }
};